import Auth from 'modules/Auth';
import Header from 'components/common/Header';
import SubNavigation from 'components/common/SubNavigation';
import { PermissionsEnum } from 'consts/permissions';

const UserManagementHeader: React.FC = () => {
  const userManagementTabs = [
    {
      id: 1,
      path: '/user-management/users',
      isVisible: true,
      name: 'Users',
    },
    {
      id: 2,
      path: '/user-management/roles',
      isVisible: Auth.hasPermission(PermissionsEnum.USERS_ROLES),
      name: 'Roles',
    },
  ];

  return <Header title="User management" subNavigation={<SubNavigation tabsConfig={userManagementTabs} />} />;
};

export default UserManagementHeader;
